var __rspack_ns_object = JSON.parse('{"Jp":"/roaming","AW":"fe-roaming"}')